
import {Injectable} from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpXsrfTokenExtractor } from "@angular/common/http";
import { Observable } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class HttpXsrfInterceptor implements HttpInterceptor {

  constructor(private tokenService: HttpXsrfTokenExtractor){}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const lcUrl = req.url.toLowerCase();
    const isAbsolute = lcUrl.startsWith('http://') || lcUrl.startsWith('https://');

    // `withCredentials: true` forces the browser into credentials mode, which
    // requires the server to reply with a specific (non-wildcard)
    // `Access-Control-Allow-Origin`. That's fine for our backend but breaks
    // direct-to-S3 uploads (presigned PUTs) because S3 returns `*`. Only
    // attach credentials for requests that stay on the current origin — i.e.
    // our backend — and leave third-party absolute URLs alone.
    const isCrossOrigin =
      isAbsolute &&
      typeof window !== 'undefined' &&
      !lcUrl.startsWith(window.location.origin.toLowerCase() + '/');

    if (!isCrossOrigin) {
      req = req.clone({
        withCredentials: true // send cookies on same-origin backend requests
      });
    }

    /*
       Angular does not set X-XSRF-TOKEN for absolute urls (urls starting with http:// or https://),
       so only process absolute urls here, but skip GET or HEAD since they don't require the XSRF token
     */
    if (!isAbsolute || req.method === 'GET' || req.method === 'HEAD') {
      return next.handle(req);
    }

    // Don't attach our XSRF token to cross-origin uploads either — it's
    // meaningless to S3 and just adds a header S3 hasn't allowlisted, which
    // would trigger another preflight failure.
    if (isCrossOrigin) {
      return next.handle(req);
    }

    const token = this.tokenService.getToken();
    // Be careful not to overwrite an existing header of the same name.
    if (token !== null && !req.headers.has('X-XSRF-TOKEN')) {
      req = req.clone({ headers: req.headers.set('X-XSRF-TOKEN', token) });
    }
    return next.handle(req);
  }
}
